import { getTreeFromDb } from './publishData';
import { setUser } from '../action/userActions';
import { Config } from '../config';
import axios from 'axios';
import { addNotification } from '../action/notificationAction';
import { getToken } from '../adal/adalConfig';
import getHeaders from './header';



/**
 * start up process which grabs data user needs
 * @param {*} authToken passed through when logged in
 */
export function startUp(auth) {
    return new Promise(async (resolve, reject) => {
        console.log("Start up has began");
        const authToken = auth || await getToken();
        try {
            let user;
            if (!sessionStorage.getItem('da-user')) {
                user = await userSetter(authToken);
                settingAuthTokenLocal(authToken);
                settingUser(user);
            } else {
                user = JSON.parse(sessionStorage.getItem('da-user'));
            }
            setUser({ authToken: authToken, user: user });
            const userPrivilege = user.privilege;
            if (userPrivilege === "ADMIN") {
                // const publish = await getPublishedTrees();
                // .then((response) => {
                // setPublishTables(publish);
                // const creation = await gatherCreation();
                addNotification({ status: "success", message: "Sucessfully logged in and loaded admin data" });
                // setProcess(creation);
                resolve();
            } else {
                getTreeFromDb();
                // const sources = await gatherSources()
                // setSource(sources);
                addNotification({ status: "success", message: "Sucessfully logged in" });
                resolve();
            }
        } catch (error) {
            addNotification({ status: "fail", message: "Could not get users trees" });
            reject(error);
        }
    });
}

/**
 * sets the users object into local storage
 * @param {*} user user object
 */
function settingUser(user) {
    const savedUser = sessionStorage.getItem('da-user');
    if (savedUser === null || savedUser !== user) {
        console.log("setting user");
        sessionStorage.setItem('da-user', JSON.stringify(user));
    }

}
/**
 * sets the token in local storage
 * @param {*} authToken auth token
 */
function settingAuthTokenLocal(authToken) {
    let savedAuth = sessionStorage.getItem('auth-token');
    if (savedAuth === null || savedAuth !== authToken) {
        console.log("setting auth token");
        sessionStorage.setItem('auth-token', authToken);
    }
}
/**
 * calls whos this api which returns back the user data to save, if they're allowed in
 * @param {*} authToken auth token of the logged in user
 */
function userSetter(authToken) {
    return new Promise(async (resolve, reject) => {
        let url = Config[Config.env].functionappurl + "api/whosThis";
        const headers = await getHeaders();

        axios.get(url, { headers: headers }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e);
        });
    });
}


// WEBPACK FOOTER //
// ./src/services/startUp.js